import { createStore } from 'zustand/vanilla';
import { useStore } from 'zustand';

interface State {
    dropdownMap: Record<string, Record<string, boolean> | undefined>;
}

interface Actions {
    toggleServiceOrder: (serviceOrderId: string, value: boolean) => void;
    toggleOrderItem: (parentServiceOrderId: string, orderItemId: string, value: boolean) => void;
}

const collapseStore = createStore<State & Actions>((set) => ({
    dropdownMap: {},
    toggleOrderItem: (parentServiceOrderId: string, orderItemId: string, value: boolean) =>
        set((state) => {
            const parent = state.dropdownMap[parentServiceOrderId] || {};

            return {
                dropdownMap: {
                    ...state.dropdownMap,
                    [parentServiceOrderId]: {
                        ...parent,
                        [orderItemId]: value,
                    },
                },
            };
        }),
    toggleServiceOrder: (serviceOrderId: string, value: boolean) =>
        set((state) => {
            const obj = value ? state.dropdownMap[serviceOrderId] || {} : undefined;

            return {
                dropdownMap: {
                    ...state.dropdownMap,
                    [serviceOrderId]: obj,
                },
            };
        }),
}));

export const { toggleServiceOrder, toggleOrderItem } = collapseStore.getState();
export const useIsServiceOrderExpanded = (serviceOrderId: string) => {
    const map = useStore(collapseStore, (store) => store.dropdownMap);
    return !!map[serviceOrderId];
};

export const useIsOrderItemExpanded = (parentServiceOrderId: string, orderItemId: string) => {
    const map = useStore(collapseStore, (store) => store.dropdownMap[parentServiceOrderId]);
    return !!map?.[orderItemId];
};
